<template>
  <div class="language-select dropdown" id="language-select">
    <a class="dropdown-toggle" v-on:click="setShow" href="#" data-toggle="dropdown" id="language" aria-haspopup="true" aria-expanded="true">
      <i class="" v-bind:class="flag"></i>
    </a>
    <div class="dropdown-menu" aria-labelledby="language" v-bind:class="{show}">
      <div class="dropdown-item cursor" v-on:click="setLang('us')">
        <span class="flag-icon flag-icon-us"></span>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('hu')">
        <i class="flag-icon flag-icon-hu"></i>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('ie')">
        <i class="flag-icon flag-icon-ie"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';

  export default {
    name: 'LngChooser',
    mounted() {
      const modul = this;
      if (localStorage.getItem("lang")) {
        modul.lang = localStorage.getItem("lang");
      } else {
        if (modul.lngs && modul.lngs.indexOf && modul.lngs.indexOf(navigator.language.substr(0,2))){
          modul.lang = navigator.language.substr(0,2)
        } else {
          modul.lang = modul.lngs[0];
        }
        modul.lang = navigator.language.substr(0,2)
      }

//      if (localStorage.lang) {
//        this.lang = localStorage.lang;
//      }
    },
    data() {
      return {
        lang: "en",
        show: ""
        , flag: "flag-icon flag-icon-us"
        , lngs: ['us','en', 'hu', 'ie']
      };
    },
    watch: {
      lang: function (newData, oldData) {
        const modul = this;
        i18n.locale = newData;
        localStorage.setItem("lang",modul.lang);
        modul.flag = "flag-icon flag-icon-" + modul.lang;
        modul.$eventBus.$emit('globalSetLang', newData);
      }
    },
    methods: {
      setShow(e){
        const modul = this;
        if (modul.show !== "show") {
          modul.show = "show";
        } else {
          modul.show = "";
        }

        return e;
      },
      setLang(lang){
        const modul = this;
        modul.lang = lang;
        modul.show = "";
        modul.flag = "flag-icon flag-icon-" + lang;
      },
//      persist() {
//        localStorage.lang = this.lang;
//      }
    }

  };
</script>

<style>
  .cursor {
    cursor: pointer;
  }
</style>
